require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.slice");

require("core-js/modules/web.dom-collections.for-each");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "vant/es/dialog/style", "vant/es/dialog", "vant/es/toast/style", "vant/es/toast"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("vant/es/dialog/style"), require("vant/es/dialog"), require("vant/es/toast/style"), require("vant/es/toast"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.style, global.dialog, global.style, global.toast);
    global.checkList = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _style, _dialog, _style2, _toast) {
  "use strict";

  var _interopRequireDefault = require("/root/deploy/iot-product-tool/node_modules/@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _dialog = _interopRequireDefault(_dialog);
  _toast = _interopRequireDefault(_toast);
  var _default = {
    name: 'XiazengCheckList',
    data: function data() {
      var ossHostPond = this.$config.base.ossHostPond;
      return {
        ossPondHost: ossHostPond,
        list: [],
        // 可提交质检的设备数
        canSubmitCount: 0,
        // 未出厂设备总数
        unfinishedCount: 0,
        // 提交中
        submitting: false
      };
    },
    created: function created() {
      this.loadCheckList();
    },
    methods: {
      // 编号只展示后六位, 前面加...; 空值原样返回
      maskLastSix: function maskLastSix(num) {
        return num && num.length > 6 ? '...' + num.slice(-6) : num || '';
      },
      // 获取设备列表
      loadCheckList: function loadCheckList() {
        var vm = this;

        var toast = _toast.default.loading({
          message: '加载中',
          forbidClick: true,
          duration: 0
        });

        vm.$http({
          method: 'GET',
          url: vm.$config.base.XIAZENG_BASE_URL + 'xia/factory/devices',
          params: {
            online: true
          }
        }).then(function (res) {
          toast.clear();
          var devices = res.data && res.data.devices || [];
          var list = Array.isArray(devices) ? devices : [];
          var canSubmitCount = 0;
          list.forEach(function (item) {
            var ps = item.processState || {}; // 质检通过: 配置成功 + 打样完成 + 按键已检测 + 正式注册成功

            item.passed = ps.configState === 'SUCCESS' && ps.sampleState === 'COMPLETED' && ps.buttonChecked === true && ps.formalRegisterState === 'SUCCESS'; // 展示编号: 已通过显示 serverUniqueId; 未通过优先 imei, 无 imei 用 iccid, 均只展示后六位

            item.displayNum = item.passed ? ps.serverUniqueId || '' : vm.maskLastSix(item.imei || item.iccid);

            if (item.passed && !item.qcDone) {
              canSubmitCount++;
            }
          });
          vm.list = list;
          vm.canSubmitCount = canSubmitCount;
          vm.unfinishedCount = list.filter(function (item) {
            return !item.qcDone;
          }).length;
        }).catch(function () {
          toast.clear();
        });
      },
      // 点击刷新按钮
      onclickRefreshBtn: function onclickRefreshBtn() {
        this.loadCheckList();
      },
      // 点击亮灯
      onclickLightBtn: function onclickLightBtn(index) {
        var vm = this;
        var item = vm.list[index];

        if (!item.iccid) {
          (0, _toast.default)('设备ICCID为空');
          return;
        }

        var toast = _toast.default.loading({
          message: '亮灯中...',
          forbidClick: true,
          duration: 0
        });

        vm.$http({
          method: 'POST',
          url: vm.$config.base.XIAZENG_BASE_URL + "xia/factory/device/".concat(item.iccid, "/light/blink?duration=5")
        }).then(function () {
          toast.clear();
          (0, _toast.default)('设备指示灯已闪烁');
        }).catch(function () {
          toast.clear();
        });
      },
      // 点击去质检/查看 - 跳转单台质检详情
      onclickGoQaBtn: function onclickGoQaBtn(index) {
        sessionStorage.setItem('xiazengCheckList', JSON.stringify(this.list));
        this.$router.push({
          path: './qaEngine',
          query: {
            index: index,
            mode: 'check'
          }
        });
      },
      // 点击提交质检按钮
      onclickSubmitBtn: function onclickSubmitBtn() {
        var vm = this;
        if (!vm.canSubmitCount || vm.submitting) return;

        _dialog.default.confirm({
          title: '提交质检',
          message: "\u5F53\u524D\u6709".concat(vm.canSubmitCount, "\u53F0\u8BBE\u5907\u5DF2\u901A\u8FC7\u8D28\u68C0\uFF0C\u662F\u5426\u63D0\u4EA4\u51FA\u5382\uFF1F"),
          confirmButtonText: '提 交',
          cancelButtonText: '取 消'
        }).then(function () {
          vm.doSubmitAll();
        }).catch(function () {});
      },
      // 逐台提交质检 - 调用 confirmServerLogin 确认正式服务登录
      doSubmitAll: function doSubmitAll() {
        var vm = this;
        var submitList = vm.list.filter(function (item) {
          return item.passed && !item.qcDone;
        });
        if (!submitList.length) return;
        vm.submitting = true;

        var toast = _toast.default.loading({
          message: "\u63D0\u4EA4\u4E2D(0/".concat(submitList.length, ")"),
          forbidClick: true,
          duration: 0
        });

        var index = 0;

        var submitNext = function submitNext() {
          if (index >= submitList.length) {
            toast.clear();
            vm.submitting = false;
            (0, _toast.default)('全部提交成功');
            vm.loadCheckList();
            return;
          }

          var item = submitList[index];
          var uniqueId = (item.processState || {}).serverUniqueId || '';
          vm.$http({
            method: 'POST',
            url: vm.$config.base.XIAZENG_BASE_URL + "xia/factory/confirmServerLogin?uniqueId=".concat(uniqueId)
          }).then(function () {
            index++;
            toast.clear();
            toast = _toast.default.loading({
              message: "\u63D0\u4EA4\u4E2D(".concat(index, "/").concat(submitList.length, ")"),
              forbidClick: true,
              duration: 0
            });
            submitNext();
          }).catch(function () {
            toast.clear();
            vm.submitting = false;
            (0, _toast.default)("\u8BBE\u5907".concat(item.iccid, "\u63D0\u4EA4\u5931\u8D25"));
            vm.loadCheckList();
          });
        };

        submitNext();
      }
    }
  };
  _exports.default = _default;
});